/* Recently viewed: server-rendered cards, local to this browser and market, with no product lookup on page load.
   The templates stay outside product-recommendations so its :empty warm-up contract remains intact. */
(function () {
  var KEY = 'atRecent';
  var MAX_AGE = 30 * 24 * 60 * 60 * 1000;

  function read(market) {
    try {
      var saved = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(saved)) return [];
      var now = Date.now();
      var handles = new Set();
      return saved.filter(function (item) {
        return item && typeof item.handle === 'string' && typeof item.html === 'string' &&
          Number.isFinite(item.t) && item.t <= now && now - item.t < MAX_AGE && item.market === market;
      }).sort(function (a, b) { return b.t - a.t; }).filter(function (item) {
        if (handles.has(item.handle)) return false;
        handles.add(item.handle);
        return true;
      }).slice(0, 12);
    } catch (e) {
      return []; // Private mode, malformed storage or a denied storage permission: suggestions still work.
    }
  }

  document.querySelectorAll('template[data-at-recent-card]').forEach(function (source) {
    var root = document.getElementById(source.dataset.atRecentCard);
    var shell = document.querySelector('template[data-at-recent-tabs="' + source.dataset.atRecentCard + '"]');
    if (!root || !shell || root.atRecent) return;
    root.atRecent = true;
    var handle = source.dataset.handle;
    var market = source.dataset.market;
    var recommendations;

    function render() {
      if (!root.dataset.recommendationsState) return;
      recommendations = root.querySelector('[data-at-recommendations]') || recommendations;
      var recent = document.createElement('template');
      read(market).filter(function (item) { return item.handle !== handle; }).slice(0, 8).forEach(function (item) {
        var card = document.createElement('template');
        card.innerHTML = item.html;
        if (card.content.childElementCount === 1 && card.content.firstElementChild.matches('article.at-card')) {
          recent.content.appendChild(card.content.firstElementChild);
        }
      });
      if (!recommendations && !recent.content.childElementCount) {
        root.replaceChildren();
        root.classList.add('is-empty', 'hidden');
        return;
      }
      var content = shell.content.cloneNode(true);
      var tabs = Array.from(content.querySelectorAll('[role=tab]'));
      var panels = Array.from(content.querySelectorAll('[role=tabpanel]'));
      if (recommendations) panels[0].appendChild(recommendations);
      panels[1].querySelector('.at-grid').appendChild(recent.content);
      var hasRecent = !!panels[1].querySelector('.at-card');
      tabs[0].hidden = !recommendations;
      tabs[1].hidden = !hasRecent;
      content.querySelector('.at-related__tabs>span').hidden = !recommendations || !hasRecent;
      if (!recommendations) root.style.setProperty('--at-rel-rows', Math.ceil(panels[1].querySelectorAll('.at-card').length / 4));

      function select(index, focus) {
        tabs.forEach(function (tab, i) {
          var selected = i === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          panels[i].hidden = !selected;
          panels[i].inert = !selected;
          panels[i].setAttribute('aria-hidden', String(!selected));
        });
        var rail = panels[index].querySelector('.at-grid');
        if (rail) {
          rail.scrollLeft = 0;
          // Reinsert the same grid on activation: both photo queues watch childList, not hidden/inert attributes.
          // Card nodes (and hydrated ratings) survive, while the existing observers pick up the newly visible rail.
          panels[index].appendChild(rail);
        }
        if (focus) tabs[index].focus({ preventScroll: true });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { select(index, false); });
        tab.addEventListener('keydown', function (event) {
          var available = tabs.filter(function (item) { return !item.hidden; });
          var next = available.indexOf(tab);
          if (event.key === 'ArrowRight') next = (next + 1) % available.length;
          else if (event.key === 'ArrowLeft') next = (next + available.length - 1) % available.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = available.length - 1;
          else return;
          event.preventDefault();
          select(tabs.indexOf(available[next]), true);
        });
      });
      select(recommendations ? 0 : 1, false);
      root.replaceChildren(content);
      root.classList.remove('is-empty', 'hidden');
      if (typeof window.atRefreshReviews === 'function') window.atRefreshReviews();
    }

    function save() {
      var saved = read(market).filter(function (item) { return item.handle !== handle; });
      saved.unshift({ handle: handle, html: source.innerHTML, t: Date.now(), market: market });
      try { localStorage.setItem(KEY, JSON.stringify(saved.slice(0, 12))); } catch (e) { /* Storage is optional. */ }
    }

    function saveWhenIdle() {
      if (window.requestIdleCallback) window.requestIdleCallback(save);
      else {
        var channel = new MessageChannel();
        channel.port1.onmessage = function () { channel.port1.close(); channel.port2.close(); save(); };
        channel.port2.postMessage(0);
      }
    }

    root.addEventListener('at:recommendations-ready', render);
    render(); // A cached recommendation response can beat this deferred script.
    if (document.readyState === 'complete') saveWhenIdle();
    else window.addEventListener('load', saveWhenIdle, { once: true });
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) { render(); saveWhenIdle(); }
    });
  });
})();
